import { render, staticRenderFns } from "./PointByRevenueList.vue?vue&type=template&id=132355a4&"
import script from "./PointByRevenueList.vue?vue&type=script&lang=js&"
export * from "./PointByRevenueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports